import React, { lazy } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getBranches,
  getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import logo from "../../assets/images/no-image.png";
import Swal from "sweetalert2";
import ImageGallery from "react-image-gallery";
import withPermissions from "../../components/WithPermissions";
import Select from "react-select";
import MotosOperationsTable from "../../components/Tables/MotosOperationsTable";

class MotoDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: [],
      vehicles: [],
      customers: [],
      images: [],
      loading: false,
      isLoad: true,
      brands: [],
      models: [],
      selectedBrand: '',
      selectedModel: '',
      formData: {
        id: '',
        brand: '',
        branch_id: '',
        customer_id: '',
        model: '',
        plate: '',
        year: '',
        km: '',
        chassis_no: '',
        engine_no: '',
        package_name: '',
        engine_size: '',
        key_no: '',
        details: '',
        vehicleImages: [],
        maintenance_date: '',
        next_maintenance_date: '',
        inspection_date: '',
        next_inspection_date: '',
        gear_type: '',
        is_motor: true,
        cooling: '',
        body_type: '',
        fuel_type: '',
        fuel_tank: '',
        number_of_gears: '',
        stroke: '',
        cylinder: '',
        hp: '',
      }
    }
  }
  async componentDidMount() {
    document.body.classList.add(this.props.themeColor);
    this.setState({ isLoad: true });

    try {
      await Promise.all([
        this.getBrands(),
        this.getVehicleInfo(),
        getBranches(),
        getCustomers(),
      ]).then(([brands, vehicleInfo, branches, customers]) => {
        this.setState({
          branches,
          customers,
          isLoad: false,
        });
      });
    } catch (e) {
      console.error(e);
      this.setState({ isLoad: false });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.themeColor !== this.props.themeColor) {
      document.body.classList.remove(prevProps.themeColor);
      document.body.classList.add(this.props.themeColor);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(this.props.themeColor);
  }
  getBrands = async () => {
    const response = await apiCall('business/vehicle/get-moto-brands', 'get', null);
    const brandOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ brands: brandOptions });
  }
  getModels = async (brandID) => {
    const response = await apiCall('business/vehicle/get-moto-models/' + brandID, 'get', null);
    const modelOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ models: modelOptions });
  }

  handleBrandChange = async (selectedOption) => {
    const brand_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        brand: brand_id,
        model: ""
      },
      selectedBrand: option,
      selectedModel: '',
      models: []
    }));

    if (brand_id) {
      try {
        const response = await apiCall(`business/vehicle/get-moto-models/${brand_id}`, 'get', null);

        const modelOptions = response.map(model => ({
          value: model.id,
          label: model.name
        }));
        this.setState({ models: modelOptions });
      } catch (error) {
        console.error("Modelleri alırken hata oluştu:", error);
      }
    }
  }
  handleModelChange = async (selectedOption) => {
    const model_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        model: model_id
      },
      selectedModel: option,
    }));
  }
  getVehicleInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/vehicle/moto-info/' + id, 'get', null);
      const { formData } = this.state;
      await this.getModels(response.moto_brand.id);
      const updatedFormData = {
        ...formData,
        id: response.id,
        brand: response.moto_brand.id,
        model: response.moto_model.id,
        cooling: response.moto_model.cooling || "Bulunamadı",
        body_type: response.moto_model.body_type,
        fuel_type: response.moto_model.fuel_type,
        fuel_tank: response.moto_model.fuel_tank,
        number_of_gears: response.moto_model.number_of_gears,
        stroke: response.moto_model.stroke,
        cylinder: response.moto_model.cylinder,
        hp: response.moto_model.hp,
        branch_id: response.branch.id,
        customer_id: response.customer.id,
        plate: response.plate,
        year: response.year,
        km: response.km,
        gear_type: response.gear_type || '',
        chassis_no: response.chassis_no,
        engine_no: response.engine_no || '',
        package_name: response.package_name || '',
        engine_size: response.moto_model.engine_size || '',
        key_no: response.key_no || '',
        details: response.details || '',
        vehicleImages: '',
        is_motor: !!response.is_motor,
        maintenance_date: response.maintenance[0]?.maintenance_date || '',
        next_maintenance_date: response.maintenance[0]?.next_maintenance_date || '',
        inspection_date: response.inspection[0]?.inspection_date || '',
        next_inspection_date: response.inspection[0]?.next_inspection_date || '',
      };
      const baseURL = 'https://apizone.servicezone.com.tr/images/vehicle/';
      let vehicleImages = [];
      if (response.images) {
        vehicleImages = JSON.parse(response.images).map(image => ({
          original: `${baseURL}${image}`,
          thumbnail: `${baseURL}${image}`,
          name: `${image}`,
        }));
      }

      if (vehicleImages.length === 0) {
        vehicleImages.push({
          original: logo,
          thumbnail: logo,
          name: "logo-icon.png",
        });
      }
      const selectedBrandOption = {
        value: response.moto_brand.id,
        label: response.moto_brand.name,
      }
      const selectedModelOption = {
        value: response.moto_model.id,
        label: response.moto_model.name,
      }
      this.setState({
        images: vehicleImages,
        formData: updatedFormData,
        selectedBrand: selectedBrandOption,
        selectedModel: selectedModelOption,
      });
    } catch (e) {
      console.error(e)
      this.setState({ isLoad: false })
    } finally {
      this.setState({ isLoad: false });
    }
  }
  handleChange = (e) => {
    const { id, value, files } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: files ? Array.from(files) : value
      }
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const vehicleFormData = new FormData();

    Object.keys(formData).forEach(key => {
      if (Array.isArray(formData[key])) {
        formData[key].forEach(file => {
          vehicleFormData.append(`${key}[]`, file);
        });
      } else {
        vehicleFormData.append(key, formData[key]);
      }
    });
    try {
      const response = await apiCall('business/vehicle/update/' + formData.id, 'post', vehicleFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  handleImageDelete = async (name) => {
    const { formData, images } = this.state;
    const prevImgData = images;
    const updatedImages = images.filter(image => image.name !== name);
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et'
    });

    if (result.isConfirmed) {
      try {

        await apiCall('business/vehicle/delete-image', 'post', { vehicleID: formData.id, name: name })
        if (updatedImages.length === 0) {
          this.setState({ images: [{ original: logo, thumbnail: logo, name: "logo-icon.png" }] });
        } else {
          this.setState({ images: updatedImages });
        }
        Swal.fire(
          'Silindi!',
          'Resim başarıyla silindi.',
          'success'
        );
      } catch (error) {
        mainHelper.toastMessage('error', 'Resim silinirken bir hata oluştu.')
        this.setState({ images: prevImgData });
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };

  renderCustomItem = (item, index) => {
    const isFullscreen = this.state.isFullscreen;
    const { userPermissions } = this.props;
    const userHasDeleteVehicleImagePermission = userPermissions.includes('delete service vehicle image');
    return (
      <div style={{ maxWidth: '750px', margin: '0 auto', position: 'relative', overflow: 'hidden' }}>
        {item && item.original ? (
          <>
            <img src={item.original} alt="vehicleimage" style={{ width: '100%' }} />
            {item.name !== "logo-icon.png" && !isFullscreen ? (
              <button disabled={!userHasDeleteVehicleImagePermission} className="btn btn-danger btn-sm" onClick={(e) => {
                e.stopPropagation();
                this.handleImageDelete(item.name);
              }} style={{ position: "absolute", bottom: 20, left: 10 }}>
                <i className="icon-trash"></i>
              </button>
            ) : null}

            <p style={{ textAlign: 'center' }}>{item.description}</p>
          </>
        ) : (
          <img src={require("../../assets/images/logo-icon.svg")} alt="default" className="fixed-size-image" />
        )}
      </div>
    );
  };

  render() {
    const { formData, branches, customers, loading, images, brands, models, selectedBrand, selectedModel } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateVehiclePermission = userPermissions.includes('update vehicle');
    const inspection = formData.inspection_date.split(' ')[0];
    const next_inspection = formData.next_inspection_date.split(' ')[0];
    const maintenance = formData.maintenance_date.split(' ')[0];
    const next_maintenance = formData.next_maintenance_date.split(' ')[0];
    const { themeColor } = this.props;
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Motosiklet Detayları"
              Breadcrumb={[
                { name: "Motosikletler", navigate: "motos" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
              <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="m-t-30">
                  <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                </div>
                <p>Yükleniyor</p>
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="row clearfix mt-3">
                    <div className="col-lg-6 col-md-12">
                      <div className="preview">
                        <div className="gallery b4gallery">
                          <ImageGallery
                            items={images}
                            renderItem={(item, index) => (
                              <div key={index} style={{ width: '100%' }}>
                                {this.renderCustomItem(item, index)}
                              </div>
                            )}
                            onImageLoad={this.handleImageLoad}
                            lazyLoad={true}
                            loading={lazy}
                            onScreenChange={isFullscreen => this.setState({ isFullscreen })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <h6>Servis Geçmişi</h6>
                      {this.state.formData.id ?
                        <MotosOperationsTable
                          vehicleID={formData.id}
                        ></MotosOperationsTable>
                        : ""}
                      <div className="col-lg-12 text-center"><h6>Diğer Özellikler</h6></div>
                      <hr />
                      <div className="body text-center" style={{ display: "grid", gridTemplateColumns: " 1fr 1fr", gap: 10 }}>
                        <div className="grid-item">
                          <small className="text-muted">Motor Hacmi </small>
                          <p>{formData.engine_size}</p>
                        </div>
                        <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                          <small className="text-muted">Motor Tipi:</small>
                          <p>{formData.body_type}
                          </p>
                        </div>
                        <div className="grid-item">
                          <small className="text-muted">Silindir </small>
                          <p>{formData.cylinder}</p>
                        </div>
                        <div className="grid-item">
                          <small className="text-muted">Hp </small>
                          <p>{formData.hp}</p>
                        </div>
                        <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                          <small className="text-muted">Soğutma:</small>
                          <p>{formData.cooling}
                          </p>
                        </div>
                        <div className="grid-item">
                          <small className="text-muted">Zaman </small>
                          <p>{formData.number_of_gears}</p>
                        </div>
                        <div className="grid-item" style={{ display: "flex", flexDirection: "column" }}>
                          <small className="text-muted">Yakıt tank kapasitesi: </small>
                          <p>{formData.fuel_tank}</p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <form className="form" id="vehicleData" onSubmit={this.handleSubmit} encType='multipart/form-data'
                    style={{ display: "contents" }}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">

                          <h6>Motosiklet Bilgileri</h6>
                          <div className="form-group">
                            <label htmlFor="customer_id" className={`font-weight-bold ${themeColor}`}>
                              Müşteri
                            </label>
                            <select name="customer_id" id='customer_id'
                              className="form-control"
                              value={formData.customer_id}
                              onChange={this.handleChange}>
                              <option value="">Müşteri Seçiniz</option>
                              {customers && (customers.map(customer => (
                                <option key={customer.id}
                                  value={customer.id}>{customer.name + ' ' + customer.surname}</option>
                              )))}

                            </select>
                          </div>
                          <div className="form-group">
                            <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="branch_id" id='branch_id'
                              className="form-control"
                              value={formData.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id}
                                  value={branch.id}>{branch.name}</option>
                              )))}

                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="plate" className="font-weight-bold text-cyan">
                              Plaka
                            </label>
                            <input name="plate"
                              id="plate"
                              className="form-control"
                              placeholder="Plaka"
                              type="text"
                              value={formData.plate}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="brand" className="font-weight-bold text-cyan">
                              Marka
                            </label>
                            <Select
                              value={selectedBrand}
                              onChange={this.handleBrandChange}
                              options={brands}
                              placeholder="Marka Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="model" className="font-weight-bold text-cyan">
                              Model
                            </label>
                            <Select
                              value={selectedModel}
                              onChange={this.handleModelChange}
                              options={models}
                              placeholder="Model Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="year" className="font-weight-bold text-cyan">
                              Model yılı
                            </label>
                            <input name="year"
                              id="year"
                              className="form-control"
                              placeholder="Model Yılı"
                              type="number"
                              value={formData.year}
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="maintenance" className="font-weight-bold text-cyan">
                              Bakım tarihi
                            </label>
                            <input name="maintenance_date"
                              id="maintenance_date"
                              className="form-control"
                              type="date"
                              value={maintenance || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="next_maintenance" className="font-weight-bold text-cyan">
                              Sonraki bakım tarihi
                            </label>
                            <input name="next_maintenance_date"
                              id="next_maintenance_date"
                              className="form-control"
                              type="date"
                              value={next_maintenance || ""}
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">

                          <h6>&nbsp;</h6>
                          <div className="form-group">
                            <label htmlFor="gear_type" className="font-weight-bold text-cyan">
                              Vites Tipi
                            </label>
                            <select name="gear_type" id='gear_type'
                              className="form-control"
                              value={formData.gear_type}
                              onChange={this.handleChange}>
                              <option value="">Vites Tipi Seçiniz</option>
                              <option value="otomatik">Otomatik</option>
                              <option value="manuel">Manuel</option>

                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="km" className="font-weight-bold text-cyan">
                              Km
                            </label>
                            <input name="km"
                              id="km"
                              className="form-control"
                              placeholder="Km"
                              type="number"
                              value={formData.km}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="chassis_no" className="font-weight-bold text-cyan">
                              Şase No
                            </label>
                            <input name="chassis_no"
                              id="chassis_no"
                              className="form-control"
                              placeholder="Şase No"
                              type="text"
                              value={formData.chassis_no}
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="key_no" className="font-weight-bold text-cyan">
                              Anahtar No
                            </label>
                            <input name="key_no"
                              id="key_no"
                              className="form-control"
                              placeholder="Anahtar No"
                              type="text"
                              value={formData.key_no}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="details" className="font-weight-bold text-cyan">
                              Motosiklet detayları
                            </label>
                            <textarea name="details"
                              id="details"
                              className="form-control"
                              placeholder="Araç detayları"
                              value={formData.details}
                              onChange={this.handleChange}
                            />

                          </div>

                          <div className="form-group">
                            <label htmlFor="vehicleImages" className="font-weight-bold text-cyan">
                              Motosiklet resimleri ekle
                            </label>
                            <input name="vehicleImages"
                              id="vehicleImages"
                              className="form-control"
                              type="file"
                              multiple={true}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="inspection" className="font-weight-bold text-cyan">
                              Muayene tarihi
                            </label>
                            <input name="inspection_date"
                              id="inspection_date"
                              className="form-control"
                              type="date"
                              value={inspection || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="next_inspection" className="font-weight-bold text-cyan">
                              Sonraki muayene tarihi
                            </label>
                            <input name="next_inspection_date"
                              id="next_inspection_date"
                              className="form-control"
                              type="date"
                              value={next_inspection || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-block"
                                disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin"
                                  width={'24px'}
                                  height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateVehiclePermission}
                                className="btn btn-outline-primary btn-block"
                                type="submit">
                                Güncelle
                              </button>}

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  const { themeColor } = state.navigationReducer;
  return { themeColor };
};

export default withPermissions(withRouter(connect(mapStateToProps, {})(MotoDetail)));
